<template>
  <MainLayout>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <template v-for="tab in tabs">
        <v-tab :key="tab.name" :to="{ name: tab.name }" ripple>{{ $t(tab.label) }}</v-tab>
      </template>
    </v-tabs>
    <router-view></router-view>
  </MainLayout>
</template>

<script>
import { PAGE } from '@/constants/page'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'ticket3-ticket-list',
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    tabs() {
      return [
        {
          name: 'ticket3-ticket-list',
          label: 'ticket_list'
        },
        // {
        //   name: 'ticket3-agent-view',
        //   label: 'agent'
        // },
        {
          name: 'ticket3-funnel-view',
          label: 'funnel'
        },
        ...(!this.isSuperRich || (this.isSuperRich && !this.isAgentRole)
          ? [
              {
                name: 'ticket3-wrapup',
                label: 'Wrap Up'
              },
              {
                name: 'ticket3-setting',
                label: 'setting'
              }
            ]
          : [])
      ]
    },
    isSuperRich() {
      return PAGE.SUPERRICH.includes(this.selectedBot.pageid)
    },
    isAgentRole() {
      return (this.$store.state.privilege || {}).role === 'agent'
    }
  },
  async mounted() {
    this.loading = true
    const allPromise = [
      this.$store.dispatch('loadAgentGroups'),
      this.$store.dispatch('loadAgentSubGroups'),
      this.$store.dispatch('loadAgents')
    ]
    await allPromise
    this.loading = false
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/LayoutTicketManagement.vue